setTimeout(function bindTimeline() {
  var timelines = $(".cd-horizontal-timeline");
  var eventsMinDistance = 65;
  var eventsMaxDistance = 250;
  var $prev = timelines.prev();
  var totalWidth = 0;
  var outerid;

  if ($prev.hasClass("styled-chunk")) {
    outerid = $prev.attr("id");
    timelines.addClass($prev.attr("class"));
    $prev.attr("class", "");
    $prev.attr("id", outerid + "-timline-intro");
    timelines.attr("id", outerid);
    $prev.detach().prependTo(timelines);
  }

  (timelines.length > 0) && initTimeline(timelines);

  function initTimeline(timelines) {
    timelines.each(function iterateTL() {
      var timeline = $(this);
      var timelineComponents = {};
      var timelineWidth;
      //cache timeline components
      timelineComponents["timelineWrapper"] = timeline.find(".events-wrapper");
      timelineComponents["eventsWrapper"] = timelineComponents["timelineWrapper"].children(".events");
      timelineComponents["fillingLine"] = timelineComponents["eventsWrapper"].children(".filling-line");
      timelineComponents["timelineEvents"] = timelineComponents["eventsWrapper"].find("a");
      timelineComponents["timelineDates"] = parseDate(timelineComponents["timelineEvents"]);
      timelineComponents["eventsMinLapse"] = minLapse(timelineComponents["timelineDates"]);
      timelineComponents["timelineNavigation"] = timeline.find(".cd-timeline-navigation");
      timelineComponents["eventsContent"] = timeline.find(".events-content");

      //assign a left postion to the single events along the timeline
      setDatePosition(timelineComponents, eventsMinDistance);
      //assign a width to the timeline
      timelineTotWidth = setTimelineWidth(timelineComponents, eventsMinDistance);

      if (timelineTotWidth > timelineComponents["timelineWrapper"].width()) {
        timelineComponents["timelineNavigation"].find(".next").removeClass("inactive");
      }

      //the timeline has been initialize - show it
      timeline.addClass("loaded");

      //detect click on the next arrow
      timelineComponents["timelineNavigation"].on("click", ".next", function nextClick(event) {
        event.preventDefault();
        updateSlide(timelineComponents, timelineTotWidth, "next");
      });
      //detect click on the prev arrow
      timelineComponents["timelineNavigation"].on("click", ".prev", function prevClick(event) {
        event.preventDefault();
        updateSlide(timelineComponents, timelineTotWidth, "prev");
      });
      //detect click on the a single event - show new event content
      timelineComponents["eventsWrapper"].on("click", "a", function eventClick(event) {
        event.preventDefault();
        timelineComponents["timelineEvents"].removeClass("selected");
        $(this).addClass("selected");
        updateOlderEvents($(this));
        updateFilling($(this), timelineComponents["fillingLine"], timelineTotWidth);
        updateVisibleContent($(this), timelineComponents["eventsContent"]);
      });

      //on swipe, show next/prev event content
      timelineComponents["eventsContent"].on("swipeleft", function swipeLeft() {
        var mq = checkMQ();
        (mq == "mobile") && showNewContent(timelineComponents, timelineTotWidth, "next");
      });
      timelineComponents["eventsContent"].on("swiperight", function swipeRight() {
        var mq = checkMQ();
        (mq == "mobile") && showNewContent(timelineComponents, timelineTotWidth, "prev");
      });

      //keyboard navigation
      if (typeof $AM === "undefined") {
        $(document).keyup(function keyUp(event) {
          if (event.which == "37" && elementInViewport(timeline.get(0))) {
            showNewContent(timelineComponents, timelineTotWidth, "prev");
          } else if (event.which == "39" && elementInViewport(timeline.get(0))) {
            showNewContent(timelineComponents, timelineTotWidth, "next");
          }
        });
      }

      setMinHeight(timelineComponents["eventsContent"]);
    });
  }

  //retrieve translateX value of timelineComponents['eventsWrapper']
  function updateSlide(timelineComponents, timelineTotWidth, string) {
    var translateValue = getTranslateValue(timelineComponents["eventsWrapper"]);
    var wrapperWidth = Number(timelineComponents["timelineWrapper"].css("width").replace("px", ""));
    //translate the timeline to the left('next')/right('prev')

    (string == "next")
      ? translateTimeline(timelineComponents, translateValue - wrapperWidth + eventsMinDistance, wrapperWidth - timelineTotWidth)
      : translateTimeline(timelineComponents, translateValue + wrapperWidth - eventsMinDistance);
  }

  //go from one event to the next/previous one
  function showNewContent(timelineComponents, timelineTotWidth, string) {
    var visibleContent = timelineComponents["eventsContent"].find(".selected");
    var newContent = (string == "next") ? visibleContent.next() : visibleContent.prev();
    var selectedDate, newEvent;

    //if there's a next/prev event - show it
    if (newContent.length > 0) {
      selectedDate = timelineComponents["eventsWrapper"].find(".selected");
      newEvent = (string == "next") ? selectedDate.parent("li").next("li").children("a") : selectedDate.parent("li").prev("li").children("a");

      updateFilling(newEvent, timelineComponents["fillingLine"], timelineTotWidth);
      updateVisibleContent(newEvent, timelineComponents["eventsContent"]);
      newEvent.addClass("selected");
      selectedDate.removeClass("selected");
      updateOlderEvents(newEvent);
      updateTimelinePosition(string, newEvent, timelineComponents);
    }
  }

  function updateTimelinePosition(string, event, timelineComponents) {
    //translate timeline to the left/right according to the position of the selected event
    var eventStyle = window.getComputedStyle(event.get(0), null);
    var eventLeft = Number(eventStyle.getPropertyValue("left").replace("px", ""));
    var timelineWidth = Number(timelineComponents["timelineWrapper"].css("width").replace("px", ""));
    var timelineTotWidth = Number(timelineComponents["eventsWrapper"].css("width").replace("px", ""));
    var timelineTranslate = getTranslateValue(timelineComponents["eventsWrapper"]);

    if ((string == "next" && eventLeft > timelineWidth - timelineTranslate) || (string == "prev" && eventLeft < -timelineTranslate)) {
      translateTimeline(timelineComponents, -eventLeft + timelineWidth / 2, timelineWidth - timelineTotWidth);
    }
  }

  function translateTimeline(timelineComponents, value, totWidth) {
    var eventsWrapper = timelineComponents["eventsWrapper"].get(0);

    //only negative translate value
    value = (value > 0) ? 0 : value;

    //do not translate more than timeline width
    value = (!(typeof totWidth === "undefined") && value < totWidth) ? totWidth : value;
    setTransformValue(eventsWrapper, "translateX", value + "px");

    //update navigation arrows visibility
    if (value === 0) {
      timelineComponents["timelineNavigation"].find(".prev").addClass("inactive");
    } else {
      timelineComponents["timelineNavigation"].find(".prev").removeClass("inactive");
    }

    if (value == totWidth) {
      timelineComponents["timelineNavigation"].find(".next").addClass("inactive");
    } else {
      timelineComponents["timelineNavigation"].find(".next").removeClass("inactive");
    }
  }

  function updateFilling(selectedEvent, filling, totWidth) {
    //change .filling-line length according to the selected event
    var eventStyle = window.getComputedStyle(selectedEvent.get(0), null);
    var eventLeft = eventStyle.getPropertyValue("left");
    var eventWidth = eventStyle.getPropertyValue("width");
    var scaleValue;

    eventLeft = Number(eventLeft.replace("px", "")) + Number(eventWidth.replace("px", "")) / 2;
    scaleValue = eventLeft / totWidth;

    setTransformValue(filling.get(0), "scaleX", scaleValue);
  }

  function setDatePosition(timelineComponents, min) {
    //var distance, distanceNorm;
    var distanceThis;

    for (i = 0; i < timelineComponents["timelineDates"].length; i++) {
      // distance = daydiff(timelineComponents["timelineDates"][0], timelineComponents["timelineDates"][i]);
      // distanceNorm = Math.round(distance / timelineComponents["eventsMinLapse"]) + 1;
      // distanceReg = distanceNorm * min;
      distanceThis = min * i;
      timelineComponents["timelineEvents"].eq(i).css("left", (distanceThis) + "px");

      totalWidth += min;
    }
  }

  function setTimelineWidth(timelineComponents, width) {
    // var timeSpan = daydiff(timelineComponents["timelineDates"][0], timelineComponents["timelineDates"][timelineComponents["timelineDates"].length - 1]);
    // var timeSpanNorm = timeSpan / timelineComponents["eventsMinLapse"];
    // var timeSpanNorm = Math.round(timeSpanNorm) + 4;
    //var totalWidth = timeSpanNorm * width;
    // var totalWidth = timelineComponents["timelineDates"].length * width;

    timelineComponents["eventsWrapper"].css("width", totalWidth + "px");
    updateFilling(
      timelineComponents["eventsWrapper"].find("a.selected"),
      timelineComponents["fillingLine"],
      totalWidth
    );

    updateTimelinePosition("next", timelineComponents["eventsWrapper"].find("a.selected"), timelineComponents);
    return totalWidth;
  }

  function updateVisibleContent(event, eventsContent) {
    var classEnetering, classLeaving, bi, bc;
    var eventDate = event.data("date");
    var visibleContent = eventsContent.find(".selected");
    var selectedContent = eventsContent.find("[data-date=\"" + eventDate + "\"]");
    var selectedContentHeight = selectedContent.height();
    var timeline = selectedContent.parents(".cd-horizontal-timeline");

    if (selectedContent.index() > visibleContent.index()) {
      classEnetering = "selected enter-right";
      classLeaving = "leave-left";
    } else {
      classEnetering = "selected enter-left";
      classLeaving = "leave-right";
    }

    selectedContent.attr("class", classEnetering);
    visibleContent.attr("class", classLeaving).one("webkitAnimationEnd oanimationend msAnimationEnd animationend", function setAnimEnd() {
      visibleContent.removeClass("leave-right leave-left");
      selectedContent.removeClass("enter-left enter-right");
    });
    eventsContent.css("height", selectedContentHeight + "px");

    bi = selectedContent.attr("data-back-src");
    bc = selectedContent.attr("data-back-color");

    if (bi) {
      timeline.css("background-image", "url(" + bi + "\)");
    }
    // timeline.removeClass("light-gray white blue red").addClass(bc);
  }

  function updateOlderEvents(event) {
    event.parent("li").prevAll("li").children("a").addClass("older-event").end().end().nextAll("li").children("a").removeClass("older-event");
  }

  function getTranslateValue(timeline) {
    var timelineStyle = window.getComputedStyle(timeline.get(0), null);
    var timelineTranslate = timelineStyle.getPropertyValue("-webkit-transform") ||
      timelineStyle.getPropertyValue("-moz-transform") ||
      timelineStyle.getPropertyValue("-ms-transform") ||
      timelineStyle.getPropertyValue("-o-transform") ||
      timelineStyle.getPropertyValue("transform");
    var translateValue;

    if (timelineTranslate.indexOf("(") >= 0) {
      timelineTranslate = timelineTranslate.split("(")[1];
      timelineTranslate = timelineTranslate.split(")")[0];
      timelineTranslate = timelineTranslate.split(",");
      translateValue = timelineTranslate[4];
    } else {
      translateValue = 0;
    }

    return Number(translateValue);
  }

  function setTransformValue(element, property, value) {
    element.style["-webkit-transform"] = property + "(" + value + ")";
    element.style["-moz-transform"] = property + "(" + value + ")";
    element.style["-ms-transform"] = property + "(" + value + ")";
    element.style["-o-transform"] = property + "(" + value + ")";
    element.style["transform"] = property + "(" + value + ")";
  }

  //based on http://stackoverflow.com/questions/542938/how-do-i-get-the-number-of-days-between-two-dates-in-javascript
  function parseDate(events) {
    var dateArrays = [];
    events.each(function eachEvent() {
      var evDate = $(this).data("date").replace(/-/g, "/");
      var newDate = new Date(evDate);
      dateArrays.push(newDate);
    });
    return dateArrays;
  }

  function daydiff(first, second) {
    return Math.round((second - first));
  }

  function minLapse(dates) {
    //determine the minimum distance among events
    var dateDistances = [];
    var distance;
    for (i = 1; i < dates.length; i++) {
      distance = daydiff(dates[i - 1], dates[i]);
      dateDistances.push(distance);
    }
    return Math.min.apply(null, dateDistances);
  }

  /*
    How to tell if a DOM element is visible in the current viewport?
    http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
  */
  function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }

  function checkMQ() {
    //check if mobile or desktop device
    return window.getComputedStyle(document.querySelector(".cd-horizontal-timeline"), "::before").getPropertyValue("content").replace(/'/g, "").replace(/"/g, "");
  }

  function setMinHeight($eContent) {
    var minHeight = 0;
    var $events = $eContent.find("li");
    $events.each(function eachEventContent() {
      var eHeight = $(this).height();
      if (eHeight > minHeight) {
        minHeight = eHeight;
      }
    });
    $eContent.css("min-height", minHeight);
  }
},
(typeof less === "object" ? 1500 : 1));
